module.exports = {
  __init__: [ 'defaultRenderer' ],
  defaultRenderer: [ 'type', require(40) ],
  styles: [ 'type', require(41) ]
};
